import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { TemplateFoundPopup } from './TemplateFoundPopup';

const POPUP_KEY = Symbol('TEMPLATE_FOUND');

/**
 * Open the "template found" popup
 * @returns {function({displayBackButton: boolean}|null): Promise<object|null>}
 */
export const useTemplateFoundPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, TemplateFoundPopup);
  });

  return useCallback(
    ({ generationTool, displayBackButton, templateName } = {}) => {
      return new Promise((resolve) => {
        popups.openPopup(POPUP_KEY, {
          generationTool,
          displayBackButton,
          templateName,

          onSubmit: (result) => {
            popups.closePopup(POPUP_KEY);
            resolve(result);
          },
          onClose: () => {
            popups.closePopup(POPUP_KEY);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );
};
